export default __webpack_public_path__ + "static/media/Outdoor-bn.1337f942.png";